import { Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { first } from 'rxjs';
import { Table } from 'primeng/table';
import { TokenService } from 'src/app/services/common/token.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { BankDetail } from '../../registration/bank-details/bankDetails';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { MenuItem, MessageService } from 'primeng/api';
import saveAs from 'file-saver';
import { CaoService } from 'src/app/services/cao.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';

@Component({
  selector: 'app-mi-survey-subsidy-disbursement',
  templateUrl: './mi-survey-subsidy-disbursement.component.html',
  styleUrls: ['./mi-survey-subsidy-disbursement.component.scss']
})

export class MiSurveySubsidyDisbursementComponent implements OnInit {
  @ViewChild('appFarmerChallanTable', { static: true })
  public appFarmerChallanTable: Table;

  public selectedApplications: any = [];
  public appFarmerChallanModel: any = [];
  public viewChallan: boolean = false;

  public currentDate: Date;

  public challanPrintData: any = [];
  public remarks: any;
  public totalFarmerShareAmount: any = 0;

  public appVerificationItems: MenuItem[];
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];

  public date: any;
  public selectedData: any[];

  public selectedLotNumber: any;
  public lotNumbersforDropDown: any[];

  constructor(
    private messageService: MessageService,
    private deptDashBoardService: DepartmentDashboardService,
    private caoService: CaoService,
    private loader: AppLoaderService
  ) {}

  ngOnInit() {
    this.loadLotNumbers();

    this.date = new Date();
    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(
            this.selectedApplications,
            `Selected Application For MI Survey (${this.date})`
          );
        },
      },
      // {
      //   label: 'Download Pdf',
      //   icon: 'pi pi-fw pi-download',
      //   command: () => {
      //     this.downloadSheetAsPdf(
      //       this.selectedApplications,
      //       `Selected Data For Bank Challan (${this.date})`
      //     );
      //   },
      // },
    ];
  }

  loadLotNumbers() {
    this.loader.start();
    this.caoService
      .getMISubsidyLotNos()
      .pipe(first())
      .subscribe({
        next: (data) => { 
          this.lotNumbersforDropDown = data;
          this.loader.close();
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Lot Numbers is not loaded.',
          });
        },
      });
  }

  onSelectLotNumber(){
    // this.loadData(this.selectedLotNumber);
    this.appFarmerChallanModel = [];
    let selectedLot = this.selectedLotNumber.LotNo
    this.loadData(selectedLot);
  }

  loadData(lotNo) {
    this.loader.start();
    this.caoService
      .getMIPFMSExport(lotNo)
      .pipe(first())
      .subscribe({
        next: (data) => { 
          this.appFarmerChallanModel = data;
          this.loader.close();
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Farmer Applications not loaded.',
          });
        },
      });
  }

  onRowUnselect(event) {
    this.calSum();
    this.messageService.add({
      severity: 'info',
      summary: 'Product Unselected',
      detail: event.data.name,
    });
  }

  onRowSelect(event) {
    this.calSum();
    this.messageService.add({
      severity: 'info',
      summary: 'Product Selected',
      detail: event.data.name,
    });
  }

  calSum() {
    this.totalFarmerShareAmount = 0;
    this.selectedApplications.forEach((val) => {
      this.totalFarmerShareAmount += val.FarmerShare;
    });
  }

  // printMultipleChallanAtal(reqBody) {
  //   this.deptDashBoardService
  //     .printMultipleChallanAtal(reqBody)
  //     .pipe(first())
  //     .subscribe({
  //       next: (data) => {
  //         this.currentDate = new Date();
  //         this.challanPrintData = data;
  //       },
  //       error: (err) => {
  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Error Message',
  //           detail: err,
  //         });
  //       },
  //     });
  // }

  onPrint(divName) {
    // var printContents = document.getElementById(divName).innerHTML;
    // var originalContents = document.body.innerHTML;
    // document.body.innerHTML = printContents;
    // window.print();
    // document.body.innerHTML = originalContents;
    document.body.style.visibility="hidden";
    document.getElementById(divName).style.visibility='visible'
    window.print();
    document.body.style.visibility="visible";
  }

  onBack() {
    this.viewChallan = false;
  }

  onSubmit() {
    this.selectedData = [];

    this.selectedApplications.forEach((row) => {
      this.selectedData.push({
        appID: row.AppId,
        farmerId: row.FarmerId,
        programID: row.ProgID,
      });
    });

    let reqBody = {
      list: this.selectedData,
      status: 'A',
      remarks: this.remarks ? this.remarks : "",
      requestType: "ByPassBank"
    };

    this.approveOtherUsersChallan(reqBody);
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      
      { field: 'AppId', header: 'Application ID' },
      { field: 'Total_Billed_Amount', header: 'Total_Billed_Amount' },
      { field: 'Total_Cost_Verification', header: 'Total_Cost_Verification' },
      { field: 'District', header: 'District' },
      { field: 'Block', header: 'Block' },
      { field: 'Village', header: 'Village' },
      { field: 'FarmerShare', header: 'FarmerShare' },
      { field: 'lotCreateTime', header: 'lotCreateTime' },
      { field: 'Crop_Name', header: 'Crop_Name' },
      { field: 'FarmerName', header: 'FarmerName' },
      { field: 'PlantSpacing', header: 'PlantSpacing' },
      { field: 'RowSpacing', header: 'RowSpacing' },
      { field: 'gpsCoordinate', header: 'gpsCoordinate' },
      { field: 'MIArea', header: 'MIArea' },
      { field: 'LotRemarks', header: 'LotRemarks' },
      { field: 'BOQAmount', header: 'BOQAmount' },
      { field: 'BOQFarmerShare', header: 'BOQFarmerShare' },
      { field: 'PaymentType', header: 'PaymentType' },
      { field: 'AmountDeposited', header: 'AmountDeposited' },
      { field: 'Admin_FarmerShare', header: 'Admin_FarmerShare' },
      { field: 'Admin_SubsidyToFarmer', header: 'Admin_SubsidyToFarmer' },
      { field: 'Admin_SubsidyToVendor', header: 'Admin_SubsidyToVendor' },
      { field: 'Admin_FarmerRefund', header: 'Admin_FarmerRefund' },
      { field: 'Admin_ApprovalDate', header: 'Admin_ApprovalDate' },
      { field: 'CenterShare_Amount', header: 'CenterShare_Amount' },
      { field: 'StateShare_Amount', header: 'StateShare_Amount' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      });
    });
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'AppId': d.AppId,
          'Total_Billed_Amount': d.Total_Billed_Amount,
          'Total_Cost_Verification': d.Total_Cost_Verification,
          'District': d.District, 
          'Block': d.Block, 
          'Village': d.Village, 
          'FarmerShare': d.FarmerShare, 
          'lotCreateTime': d.lotCreateTime, 
          'Crop_Name': d.Crop_Name, 
          'FarmerName': d.FarmerName, 
          'PlantSpacing': d.PlantSpacing, 
          'RowSpacing': d.RowSpacing,
          'gpsCoordinate': d.gpsCoordinate,
          'MIArea': d.MIArea,
          'LotRemarks': d.LotRemarks,
          'BOQAmount': d.BOQAmount,
          'BOQFarmerShare': d.BOQFarmerShare,
          'PaymentType': d.PaymentType,
          'AmountDeposited': d.AmountDeposited,
          'Admin_FarmerShare': d.Admin_FarmerShare,
          'Admin_SubsidyToFarmer': d.Admin_SubsidyToFarmer,
          'Admin_SubsidyToVendor': d.Admin_SubsidyToVendor,
          'Admin_FarmerRefund': d.Admin_FarmerRefund,
          'Admin_ApprovalDate': d.Admin_ApprovalDate,
          'CenterShare_Amount': d.CenterShare_Amount,
          'StateShare_Amount': d.StateShare_Amount,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }


  approveOtherUsersChallan(reqBody) {
    this.loader.start();
    this.deptDashBoardService
      .approveOtherUsersChallan(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.messageService.add({
            severity: 'info',
            summary: 'Status',
            detail: JSON.stringify(data),
          });
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }
}
